import { vueKeycloak } from "@josempgon/vue-keycloak";
import type { App } from "vue";

export const installVueKeycloakPlugin = async (app: App) => {
  app.use(vueKeycloak, {
    config: {
      url: import.meta.env.VITE_KEYCLOAK_URL,
      realm: import.meta.env.VITE_KEYCLOAK_REALM,
      clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID,
    },
    initOptions: {
      onLoad: 'login-required',
      redirectUri: `${window.location.href}`,
      checkLoginIframe: false,
    },
  });
};
